import script from "./ForUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./ForUsers.vue?vue&type=script&setup=true&lang=js"

import "./ForUsers.vue?vue&type=style&index=0&id=ca628528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca628528"]])

export default __exports__